import { render, staticRenderFns } from "./myProblemManage.vue?vue&type=template&id=41d7a0e4&scoped=true&"
import script from "./myProblemManage.vue?vue&type=script&lang=js&"
export * from "./myProblemManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d7a0e4",
  null
  
)

export default component.exports